import { ProductBuilderState } from '../state'

export const productBuilderStepIndexChange = (state: ProductBuilderState, newStepIndex: number): ProductBuilderState => ({
    ...state, stepIndex: newStepIndex
})